/** Detect video from MIME type and/or URL (presigned URLs often include the object key). */
export function isVideoMedia(
  typeOrUrl?: string | null,
  url?: string | null,
): boolean {
  const type = (typeOrUrl || "").toLowerCase();
  if (type.startsWith("video/")) return true;
  const candidate = `${typeOrUrl || ""} ${url || ""}`.toLowerCase();
  return (
    candidate.includes(".webm") ||
    candidate.includes(".mp4") ||
    candidate.includes(".mov") ||
    candidate.includes("video/webm") ||
    candidate.includes("video/mp4") ||
    candidate.includes("video/quicktime")
  );
}
